"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EditAndRemoveState = /** @class */ (function () {
    function EditAndRemoveState() {
        this.showDeleteModal = false;
    }
    return EditAndRemoveState;
}());
exports.default = EditAndRemoveState;
//# sourceMappingURL=EditAndRemoveState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/common/EditAndRemove/EditAndRemoveState.js
// module id = 2266
// module chunks = 8